import { render, staticRenderFns } from "./CardItem2.vue?vue&type=template&id=87d676f4&scoped=true&"
import script from "./CardItem2.vue?vue&type=script&lang=js&"
export * from "./CardItem2.vue?vue&type=script&lang=js&"
import style0 from "./CardItem2.vue?vue&type=style&index=0&id=87d676f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d676f4",
  null
  
)

export default component.exports